// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__QjOY-","info":"Note_info__1kpw0","note":"Note_note__z9O1O","actions":"Note_actions__1le30"};